// src/App.js
import React from 'react';
import EditorPage from './components/editor/EditorPage';
import './App.css';

export default function App() {
  return (
      <div className="App">
        
        <EditorPage />
      </div>
  );
}
